import React from 'react';
// import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useNavigate,useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';
import { usePatient } from "../context/PatientContext"; 
import styles from '../Styles/navbar.module.css';  

const CNavbar = () => {
  const { user, auth, setAuth, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation(); // Get the current route
  const {doctorInfo, setDoctorInfo} = usePatient();

console.log('doctorInfo.MANDALI_ROLE', doctorInfo.MANDALI_ROLE);

  const handleLogout = () => {
    logout();
};

const handleClinicChange = (e) => {
  const selectedClinicId = parseInt(e.target.value);
  setDoctorInfo(prev => ({
    ...prev,
    CLINIC_ID: selectedClinicId
  }));
};

const clinicList = doctorInfo?.CLINIC_LIST || [];

  return (
<nav className={styles.navbar}>
      <div className={styles.container}>
        {/* Logo */}
        <Link to="/" className={styles.brand}>
          <img src="/Ayumaxfinal.png" alt="Ayumax" className={styles.logo} />
        </Link>

        {/* Navigation Links */}
        <div className={styles.navLinks}>
          {auth ? ( 
            <>
              <Link 
                to="/patientlist" 
                className={location.pathname === "/patientlist" || location.pathname === "/patient/*" ? styles.active : ""}
              >
                Patient List
              </Link>
              <Link 
                to="/addpatient" 
                className={location.pathname === "/addpatient" ? styles.active : ""}
              >
                Add Patient
              </Link>
              <Link 
                to="/getmandaliinfo" 
                className={location.pathname === "/getmandaliinfo" ? styles.active : ""}
              >
                Mandali Info
              </Link>
              <Link 
                to="/calendar" 
                className={location.pathname === "/calendar" ? styles.active : ""}
              >
                Calendar
              </Link>
              <Link
                to="/reports/payments"
                className={location.pathname === "/reports/payments" ? styles.active : ""}
              >
                Reports
              </Link>
              {doctorInfo.MANDALI_ROLE === 1 && (
                <Link 
                  to="/doctorslist" 
                  className={location.pathname === "/doctorslist" ? styles.active : ""}
                >
                  Doctors List
                </Link>
              )}

              {/* ✅ Clinic Dropdown */}
              {clinicList.length > 1 && (
                <select
                  value={doctorInfo.CLINIC_ID || ""}
                  onChange={handleClinicChange}
                  className={styles.clinicDropdown}
                >
                  {clinicList.map((clinic) => (
                    <option key={clinic.CLINIC_ID} value={clinic.CLINIC_ID}>
                      {clinic.CLINIC_NAME}
                    </option>
                  ))}
                </select>
              )}

                            {/* ✅ Show selected clinic if only one */}
              {clinicList.length === 1 && (
                <span className={styles.clinicInfo}>
                  Clinic: {clinicList[0].CLINIC_NAME}
                </span>
              )}

              <button className={styles.logout} onClick={handleLogout}>Logout</button>
            </>
          ) : (
            <>
              <Link to="/">Login</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default CNavbar;
